module.exports = __webpack_public_path__ + "img/007.37f6af2b.jpg";